//state data for changing and handling managing area users

const actions = {
  async adminCustomise({dispatch, getters}, [data, roomUpdates]){
    // This uses PUT /area.
    // We use /area instead of /area/customise for two reasons:
    // - We can update the Information Panel (which is normally a seperate endpoint) at the same time
    // - It seems we can't update colourScheme through /area/customise and no particular endpoint exists for this


    // PUT /area requires you to send the _complete_ area object with no missing fields.
    // It would be great to just use getCurrentAreaData, but it's missing a bunch of fields that the BE requires
    // such as createdAs, createdBy, etc
    // So we have to pull the entire area object from GET /area and merge it with the data we want to change.

    const id = getters.getCurrentAreaData.id
    let res = await dispatch('api/nav/getSpaceData', id)

    dispatch('analytics/customiseSpace', [data, roomUpdates])

    if (!res.success) {
      dispatch('popups/show/error/custom', 'updating your Space', {root: true})
      return
    }

    const currentAreaData = res.success.area

    const mergedData = {
      ... currentAreaData,
      ... data
    }

    res = await dispatch('api/nav/adminUpdateSpace', mergedData)

    if (!res.success) {
      dispatch('popups/show/error/custom', 'updating your Space', {root: true})
      return
    }

    // Finally, we'll have a list of room updates we want to do. These will just be name changes for the lobby and lounge.
    res = await Promise.all(
      roomUpdates.map((u) => {
        return dispatch('api/genericHandler', ['nav/updateRoom', [u.id, u], () => dispatch('popups/show/error/custom', 'updating your Space', {root: true})])
      }))

    if (res.every(r => r.success)) dispatch('popups/show/success/updating', 'Space', {root: true})
  }
};

export default {
  actions
};
